module.exports = __webpack_public_path__ + "clickup-1-f0a876dba0a508810b484e26c1db287f.webp";